<template>
  <!-- NOTE (TEMPLATE) to add new university -->

  <div class="animated fadeIn">
    <v-dialog v-model="changeLogo" max-width="600px" persistent>
      <v-card class="profile-modalCard">
        <v-card-title class="c-primary">افزودن لوگو</v-card-title>
        <br />
        <v-card-text>
          <h5 class="mb-8 text-center">
            آیا میخواهید برای دانشگاه لوگو اضافه کنید ؟
          </h5>
          <v-file-input
            @change="myUpload(file)"
            v-model="file"
            ref="upload"
            outlined
            dense
            prepend-icon="mdi-file-image-outline"
            v-show="false"
          ></v-file-input>

          <v-row class="justify-content-center mb-2 mt-1">
            <v-btn
              @click="
                addImage = true;
                uploading = false;
              "
              :loading="fileBusy"
              color="primary"
              >ثبت لوگو</v-btn
            >
            <v-btn color="red" @click="notChangeLogo()" class="text-light ml-2"
              >بعدا بارگذاری شود</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addImage" width="450">
      <v-card class="modal-card">
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xlarge">افزودن لوگو</h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="addImage = false">
                <v-icon class="pointer">mdi-close</v-icon>
              </span>
            </v-col>
          </v-row>
          <div v-if="!uploading">
            <div
              class="upload-box"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <p class="c-grey fs-large mb-2">
                فایل مورد نظر را به این قسمت بکشید
              </p>

              <p class="c-grey fs-large mb-2">یا</p>
              <v-btn
                @click="$refs.upload.$refs.input.click()"
                class="c-primary b-primary bc-white"
                elevation="0"
                height="42"
                >یافتن فایل</v-btn
              >
            </div>
          </div>
          <div v-else>
            <div class="d-flex flex-row w-100">
              <div class="file-icon">
                <v-icon large>$File</v-icon>
              </div>
              <div class="w-100 px-3">
                <p class="mb-0">در حال بارگذاری تصویر...</p>
                <v-progress-linear
                  class="mt-1"
                  outlined
                  height="4"
                  :value="myFile.uploadPercentage"
                  color="#068D9D"
                >
                </v-progress-linear>
              </div>
              <div class="c-primary pt-4">{{ myFile.uploadPercentage }}%</div>
            </div>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-file-input
      @change="myUpload(file)"
      v-model="file"
      ref="upload"
      outlined
      dense
      v-show="false"
    ></v-file-input>
    <b-card
      v-if="$router.currentRoute.path == '/admin/addUniversity'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>افزودن دانشگاه جدید</h2>
      <hr />
      <b-form-group
        label="نام دانشگاه یا مرکز تحقیقات"
        :class="newUniversity.name ? 'done' : 'required'"
      >
        <b-form-input
          trim
          v-model="newUniversity.name"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="نام کاربری (به زبان انگلیسی وارد کنید.)"
        :class="
          newUniversity.username && computedUsername ? 'done' : 'required'
        "
      >
        <b-form-input
          trim
          v-model="newUniversity.username"
          @keydown="justEng($event)"
          type="text"
        ></b-form-input>
        <span
          class="text-danger"
          v-if="newUniversity.username && !computedUsername"
          >* استفاده از حروف الزامی است!</span
        >
      </b-form-group>
      <b-form-group
        label="شماره همراه رابط"
        :class="newUniversity.mobile ? 'done' : 'required'"
      >
        <b-form-input
          trim
          v-model="newUniversity.mobile"
          type="number"
          :no-wheel="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="my-8">
        <div class="d-flex">
          <b-form-checkbox v-model="newUniversity.isDistinguished">
          </b-form-checkbox>
          <span class="ms-2 font-weight-bold">
            این دانشگاه جزو دانشگاه‌های
            <span
              class="font-weight-bold h5 mx-1 light-blue--text text--darken-4"
            >
              <v-icon class="amber--text darken-2--text">mdi-star</v-icon>
              ممتاز</span
            >
            است.
          </span>
        </div>
      </b-form-group>
      <b-form-group label="تلفن‌های تماس روابط عمومی">
        <b-form-input
          trim
          v-model="newUniversity.tel"
          :no-wheel="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="ایمیل">
        <b-form-input
          trim
          v-model="newUniversity.email"
          type="email"
          :state="validateEmail(newUniversity.email) ? null : false"
          aria-describedby="email"
        ></b-form-input>
        <b-form-invalid-feedback id="email"
          >پست الکترونیک صحیح نیست</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group label="آدرس تارنما">
        <b-form-input
          trim
          :state="checkUrl(newUniversity.website) ? null : false"
          v-model="newUniversity.website"
          type="url"
        ></b-form-input>
        <b-form-invalid-feedback id="url"
          >آدرس تارنما صحیح نیست</b-form-invalid-feedback
        >
      </b-form-group>
      <b-form-group
        description
        label="استان"
        :class="newUniversity.stateId ? 'done' : 'required'"
      >
        <v-autocomplete
          v-model="newUniversity.stateId"
          :items="iran"
          @change="newUniversity.cityId = ''"
          item-value="id"
          item-text="name"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>

      <b-form-group description label="شهر">
        <v-autocomplete
          v-model="newUniversity.cityId"
          :items="
            iran
              .filter((x) => x.id == newUniversity.stateId)
              .map((y) => y.cities)[0]
          "
          item-value="id"
          item-text="name"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>
      <b-form-group label="آدرس">
        <b-form-input
          trim
          v-model="newUniversity.address"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="کدپستی">
        <b-form-input
          trim
          v-model="newUniversity.postalCode"
          :no-wheel="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="معاون پژوهشی(تحقیقات و فناوری)">
        <b-form-input
          trim
          v-model="newUniversity.researchAssistant"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="توضیحات">
        <b-form-textarea
          v-model="newUniversity.description"
          rows="3"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group
        label="رمز عبور"
        :class="password && strongPass ? 'done' : 'required'"
      >
        <b-form-input
          trim
          v-model="password"
          @input="passStrength()"
          type="password"
          autocomplete="new-password"
        >
        </b-form-input>
      </b-form-group>
      <!--============== checking password =========== -->
      <b-row class="w-50">
        <b-col>
          <!-- NOTE check if the pass has more than 8 charector -->
          <p class="pass" :class="{ 'pass--passed': password.length > 7 }">
            <i
              class="frmIcon fa"
              :class="password.length > 7 ? 'fa-check' : 'fa-times'"
            ></i>
            حداقل ۸ نویسه
          </p>
        </b-col>
        <b-col>
          <!-- NOTE check if the pass has uppercase -->
          <p class="pass" :class="{ 'pass--passed': has_uppercase }">
            <i
              class="frmIcon fa"
              :class="has_uppercase ? 'fa-check' : 'fa-times'"
            ></i>
            دارای حروف بزرگ باشد
          </p>
        </b-col>
      </b-row>
      <b-row class="w-50">
        <b-col>
          <!-- NOTE check if the pass has lowercase -->
          <p class="pass" :class="{ 'pass--passed': has_lowercase }">
            <i
              class="frmIcon fa"
              :class="has_lowercase ? 'fa-check' : 'fa-times'"
            ></i>
            دارای حروف کوچک باشد
          </p>
        </b-col>
        <b-col>
          <!-- NOTE check if the pass has number -->
          <p class="pass" :class="{ 'pass--passed': has_number }">
            <i
              class="frmIcon fa"
              :class="has_number ? 'fa-check' : 'fa-times'"
            ></i>
            دارای عدد باشد
          </p>
        </b-col>
      </b-row>

      <!--============== checking password =========== -->
      <b-form-group
        label="تکرار رمز عبور"
        :class="
          password ? (password && checkPassword ? 'done' : 'required') : ''
        "
      >
        <b-form-input
          trim
          v-model="repeatPassword"
          type="password"
          aria-describedby="repeat-password"
          :state="checkPassword"
        ></b-form-input>
        <b-form-invalid-feedback id="repeat-password"
          >رمز عبور با تکرار آن همخوانی ندارد</b-form-invalid-feedback
        >
      </b-form-group>

      <!-- NOTE (b-addUniversity) to add new university -->
      <v-btn
        class="green-btn"
        :disabled="
          isBusy ||
          checkPassword == false ||
          !newUniversity.username ||
          !computedUsername ||
          !newUniversity.name ||
          !password ||
          !repeatPassword ||
          !password.length > 7 ||
          !has_uppercase ||
          !has_lowercase ||
          !has_number ||
          !checkUrl(newUniversity.website) ||
          !validateEmail(newUniversity.email)
        "
        @click="addUniversity()"
      >
        <v-icon class="me-2">mdi-check</v-icon>
        ثبت دانشگاه</v-btn
      >
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import utilities from "../../mixins/utilities"; // REVIEW
import md5 from "js-md5";
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import validator from "validator";
import isURL from "validator/lib/isURL";

export default {
  components: { Select2, isURL, validator },
  mixins: [utilities], // REVIEW
  data() {
    return {
      newUniversity: {},
      password: "",
      repeatPassword: "",
      iran: [],
      isBusy: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      logoPic: "",
      logoId: "",
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      changeLogo: false,
      universityId: "",
      fileBusy: false,
      addImage: false,
      uploading: false,
    };
  },
  computed: {
    checkPassword() {
      // NOTE (c-checkPassword) to check the university password
      return this.password
        ? this.password == this.repeatPassword
          ? true
          : false
        : null;
    },
    computedUsername() {
      if (!/^[a-zA-Z]+$/.test(this.newUniversity.username)) {
        if (/^[0-9]+$/.test(this.newUniversity.username)) {
          return false;
        } else {
          return true;
        }
      } else return true;
    },
    strongPass() {
      // NOTE (c-checkPassword) to check the university password
      return this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.password.length > 7
        ? true
        : false;
    },
  },

  methods: {
    passStrength() {
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);
    },
    justEng(str) {
      if (!/^[a-zA-Z0-9]+$/.test(str.key)) {
        str.key != "Backspace" && str.key != "Tab" ? str.preventDefault() : "";
      }
    },
    checkUrl(url) {
      if (this.newUniversity.website) {
        if (validator.isURL(url)) {
          return true;
        } else {
          return false;
        }
      } else return true;
    },
    addUniversity() {
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.password.length > 7
      ) {
        this.isBusy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/admin/university/new",
            {
              name: this.newUniversity.name,
              username: this.newUniversity.username,
              researchAssistant: this.newUniversity.researchAssistant,
              mobile: this.newUniversity.mobile,
              tel: this.newUniversity.tel,
              email: this.newUniversity.email,
              website: this.newUniversity.website,
              stateId: this.newUniversity.stateId ? this.newUniversity.stateId : null,
              postalCode: this.newUniversity.postalCode,
              cityId: this.newUniversity.cityId ? this.newUniversity.cityId : null,
              address: this.newUniversity.address,
              description: this.newUniversity.description,
              password: md5(this.password),
              isDistinguished: this.newUniversity.isDistinguished,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast("دانشگاه با موفقیت اضافه گردید", "success");
            this.universityId = res.data;
            this.changeLogo = true;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            if (err.response.status == 403) {
              if (err.response.data == "expired")
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
              // else this.$router.replace("/unauthorize");
              else
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
            }
            this.isBusy = false;
          });
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
    getStatesAndCities() {
      this.$http
        .get(
          this.baseUrl + "/setad/options/states/list",
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (this.addImage) {
          if (Array.from(this.file).length > 1) {
            this.toast(
              " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
              "error"
            );
            return;
          }
        }
        Array.from(this.file).forEach((file) => {
          this.myUpload(file);
        });
      }
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    myUpload(file) {
      // NOTE (m-myUpload) to upload files
      //this.changeLogo = false;
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد. ", "error");
        return;
      } else {
        this.fileBusy = true;
        this.uploading = true;
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/university/avatar?universityId=" +
              this.universityId,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.toast("تصویر با موفقیت افزوده شد", "success");
              setTimeout(() => {
                router.push("/admin/universities");
              }, 1000);
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }
    },
    notChangeLogo() {
      this.changeLogo = false;
      router.push("/admin/universities");
    },
  },

  mounted() {
    this.getStatesAndCities();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.modal-card {
  .upload-box {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='rgb(6, 141, 157)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='5' stroke-linecap='butt'/%3e%3c/svg%3e");
  }
  .file-icon {
    path {
      stroke: #068d9d;
    }
  }
}
</style>
<style scoped lang="scss">
.uploadPercentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: rgba(19, 18, 18, 0.726);
  text-align: center;
  z-index: 70;
  padding: 10px;
  span {
    color: whitesmoke;
    margin: auto;
    font-size: 0.9rem;
  }
}

.color {
  background-color: #0c4961;
  color: white;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
.required {
  color: red;
}

.done {
  color: green;
}
</style>
